import { Trait } from '../../trait.type';
import { TraitRegistry, TraitType } from '../../trait-registry';
import { StatusEffect } from '../../status-effects.type';

export class AffinityFireTrait extends Trait {
  static baseType = TraitType.AffinityFire;
  static baseTitle = 'Elemental Affinity (Fire)';
  static baseText = 'Immune to Burning and Purge.';
  static baseIcon = 'trait';

  type = AffinityFireTrait.baseType;
  title = AffinityFireTrait.baseTitle;
  text = AffinityFireTrait.baseText;
  icon = AffinityFireTrait.baseIcon;

  modifierAdd(type: StatusEffect, stacks: number) {
    // TODO, prevent purge
    if (type == StatusEffect.Burning) {
      return 0;
    }
    return stacks;
  }
}

TraitRegistry.register(AffinityFireTrait.baseType, AffinityFireTrait);
